import React from 'react';
import moment from 'moment';

import PropTypes from 'prop-types';
import ManagedDatePicker from '../../../../../common/ManagedDatePicker';

import { DateFilterContainer } from '../css';
import { Box, Text } from '../../../../../design/css';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';
import { getLocale, localeEn } from '../../../../../misc';

const FilterByDates = ({ filters, setFilters }) => {
  const {
    ORDERS: {
      startDateLabel,
      endDateLabel,
      filterByOpenDate,
      filterBySubmissionDate
    }
  } = useLocalizedStringsContext();
  const locale = getLocale();
  const copy = locale === localeEn ? 'en' : 'fr';
  const isDayAfterToday = day => day.isAfter(moment(), 'day');

  const {
    endDateOpenDate,
    endDateSubmissionDate,
    startDateOpenDate,
    startDateSubmissionDate
  } = filters;

  return (
    <DateFilterContainer onFocus={() => window.dispatchEvent(new Event('scroll'))}>
      <Box>
        <div style={{ marginBottom: '0.5rem' }}>
          <Text>{filterByOpenDate}</Text>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="iot-filter-start-open"
              label={startDateLabel}
              disabled={!!(startDateSubmissionDate || endDateSubmissionDate)}
              value={startDateOpenDate || ''}
              onValueChange={v =>
                setFilters({ ...filters, startDateOpenDate: v })
              }
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="iot-filter-end-open"
              label={endDateLabel}
              disabled={!!(startDateSubmissionDate || endDateSubmissionDate)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              value={endDateOpenDate || ''}
              onValueChange={v => setFilters({ ...filters, endDateOpenDate: v })}
              copy={copy}
            />
          </div>
        </div>
      </Box>
      <Box>
        <div style={{ marginBottom: '0.5rem' }}>
          <Text>{filterBySubmissionDate}</Text>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="iot-filter-start-sub"
              label={startDateLabel}
              disabled={!!(startDateOpenDate || endDateOpenDate)}
              value={startDateSubmissionDate || ''}
              onValueChange={v =>
                setFilters({ ...filters, startDateSubmissionDate: v })
              }
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="iot-filter-end-sub"
              label={endDateLabel}
              disabled={!!(startDateOpenDate || endDateOpenDate)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              value={endDateSubmissionDate || ''}
              onValueChange={v =>
                setFilters({ ...filters, endDateSubmissionDate: v })
              }
              copy={copy}
            />
          </div>
        </div>
      </Box>
    </DateFilterContainer>
  );
};

FilterByDates.propTypes = {
  filters: PropTypes.shape({
    endDateOpenDate: PropTypes.string,
    endDateSubmissionDate: PropTypes.string,
    startDateOpenDate: PropTypes.string,
    startDateSubmissionDate: PropTypes.string
  }).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByDates;
